import { RootState } from '@src/redux/store'
import { pathOr, prop, propOr } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  LESSON,
  LESSON_ALL,
  LESSON_ASSESSMENT,
  LESSON_ASSESSMENT_ALL,
  LESSON_ASSESSMENT_LIST,
  LESSON_ATTENDANCE,
  LESSON_ATTENDANCE_GROUP,
  LESSON_CREATE,
  LESSON_DISTANCE_LEARNING_ALL,
  LESSON_DOWNLOAD_FILES,
  LESSON_HOMEWORK_UPLOAD,
  LESSON_LIST,
  LESSON_MARK_ASSESSMENT,
} from '../constants/actionTypes'

const lessonsSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const lessonSelector = createSelector(lessonsSelector, data => data[LESSON])

export const lessonListSelector = createSelector(lessonsSelector, data => data[LESSON_LIST])

export const lessonAllSelector = createSelector(lessonsSelector, data => data[LESSON_ALL])

export const lessonCreateSelector = createSelector(lessonsSelector, data => data[LESSON_CREATE])

export const lessonHomeworkUploadSelector = createSelector(lessonsSelector, data => data[LESSON_HOMEWORK_UPLOAD])

export const lessonAssessmentSelector = createSelector(lessonsSelector, data => data[LESSON_ASSESSMENT])

export const lessonAssessmentAllSelector = createSelector(lessonsSelector, data => data[LESSON_ASSESSMENT_ALL])

export const lessonAssessmentListSelector = createSelector(lessonsSelector, data => data[LESSON_ASSESSMENT_LIST])

export const lessonMarkAssessmentSelector = createSelector(lessonsSelector, data => data[LESSON_MARK_ASSESSMENT])

export const lessonDownloadFilesSelector = createSelector(lessonsSelector, data => data[LESSON_DOWNLOAD_FILES])

export const disLearningLessonAllSelector = createSelector(lessonsSelector, data => data[LESSON_DISTANCE_LEARNING_ALL])

export const lessonAttendanceSelector = createSelector(lessonsSelector, data => data[LESSON_ATTENDANCE])

export const lessonAttendanceGroupSelector = createSelector(lessonsSelector, data => data[LESSON_ATTENDANCE_GROUP])

export const lessonAllOptionsSelector = createSelector(lessonAllSelector, selected => {
  return {
    loading: selected.loading,
    error: selected.error,
    options: Array.isArray(selected.data)
      ? selected.data.map(item => ({
          label: `${propOr('', 'name', item)} (${pathOr('', ['calendar_event_info', 'title'], item)})`,
          value: prop('id', item),
          children: Array.isArray(item.children)
            ? item.children.map(child => ({
                label: pathOr('', ['type', 'title'], child),
                value: prop('id', child),
              }))
            : [],
        }))
      : [],
  }
})
